/**
 * Returns true if `possibleMainGroup` should be visible for the given
 * media type, per searchViewConfig.
 *
 * Single source of truth for main-group visibility — used by both the tab
 * builder (search-page-action-row.js) and the count-query builder
 * (asset-search.js) so the two lists can never diverge.
 */
export const isMainGroupVisible = (possibleMainGroup, mediaType, searchViewConfig) => {
  if (possibleMainGroup.type !== mediaType) {
    return false;
  }
  if (
    ["editorial", "creative", "microstock", "customer", "panther"].indexOf(
      possibleMainGroup.mainGroup
    ) >= 0
  ) {
    if (possibleMainGroup.mainGroup === "customer") {
      return searchViewConfig.showCustomer;
    } else if (!searchViewConfig.showCustomerOnly) {
      if (possibleMainGroup.mainGroup === "panther") {
        return searchViewConfig.hasPanther;
      }
      return true;
    }
    return false;
  }
  if (["video", "microstockvideo"].indexOf(possibleMainGroup.mainGroup) >= 0) {
    return !searchViewConfig.showCustomerOnly;
  }
  return true;
};
